import {createApi} from '@reduxjs/toolkit/query/react';
import {AxiosRequestHeaders} from 'axios';

import httpBaseQuery from '../../../shared/api/rtk-query/httpBaseQuery';
import {ApiUrls} from '../../../shared/config/model/urls';
import IServerIncident from '../model/ServerIncident/IServerIncident';
import IHydraResponse from '../../../shared/api/model/HydraResponse';
import IPagination from '../../../shared/api/model/IPagination';
import {paginationAdapter} from '../../../shared/api/paginationHelper';
import {providesListUuid} from '../../../shared/api/rtk-query/RTKQueryHelper';
import {buildQuery} from '../../../shared/api/query';
import ICollectionParams from '../../../shared/api/model/ICollectionParams';

export const serverIncidentAPI = createApi({
    reducerPath: 'serverIncidentAPI',
    baseQuery: httpBaseQuery(),
    tagTypes: ['ServerIncident'],
    refetchOnMountOrArgChange: 60,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        getServerIncidents: build.query<IPagination<IServerIncident>, ICollectionParams>({
            query: ({page, sort, filters, limit}) => ({
                path: buildQuery(ApiUrls.SERVER_INCIDENTS(page, sort, filters, limit)),
                headers: {Accept: 'application/ld+json'} as unknown as AxiosRequestHeaders,
            }),
            providesTags: (result) => providesListUuid(result?.items, 'ServerIncident'),
            transformResponse(
                rawResult: IHydraResponse<IServerIncident>,
            ): Promise<IPagination<IServerIncident>> | IPagination<IServerIncident> {
                return paginationAdapter(rawResult);
            },
        }),
        getServerIncident: build.query<IServerIncident, string>({
            query: (uuid) => ({
                path: ApiUrls.SERVER_INCIDENT(uuid),
            }),
            providesTags: (result, error, uuid) => [{ type: 'ServerIncident', id: uuid }],
        }),
    }),
});
